import styled from 'styled-components'
import { Box } from '@telus-uds/components-web'

export const StyledBox = styled(Box)`
  padding-top: 0.5rem;
  &:empty {
    display: none;
  }
`
/* 
  > div:first-child case
  Separates the top-most notification from the PageHeading with padding-top

  > div:empty:not(...) case
  Edge case to dynamically add padding-top to the top-most notification
  in cases where other notifications are closed, e.g. CallAgent/Messages
*/
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  > div:first-child {
    @media screen and (max-width: 991px) {
      padding-top: 1.5rem;
    }
    @media screen and (min-width: 991px) {
      padding-top: 2rem;
    }
  }
  > div:empty:not(div:not(:empty) ~ div:empty) + div:not(:empty) {
    @media screen and (max-width: 991px) {
      margin-top: 16px;
      padding-top: 1.5rem;
    }
    @media screen and (min-width: 991px) {
      margin-top: 24px;
      padding-top: 2rem;
    }
  }
`
